"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ListingFilterTab',
    props: {
        value: {
            type: String,
            default: null,
        },
        current: {
            type: String,
            default: null,
        },
    },
    emits: ['click'],
    setup(__props, { emit }) {
        const props = __props;
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                class: (0, vue_2.normalizeClass)(["rounded-full py-4 px-1 uppercase font-semibold transition-colors focusable text-[0.6875rem] md:font-base", __props.value === __props.current ? 'bg-beige-200' : '']),
                onClick: _cache[0] || (_cache[0] = ($event) => (emit('click', __props.value)))
            }, [
                (0, vue_2.renderSlot)(_ctx.$slots, "default")
            ], 2));
        };
    }
});
